import { EasyBorrowFormNormalizedData } from './types'
import { Objective } from '@/features/actions/logic/types'

export function useCreateObjectives(formValues: EasyBorrowFormNormalizedData): Objective[] {
  return [...createDepositObjectives(formValues), ...createBorrowObjectives(formValues)]
}

function createDepositObjectives(formValues: EasyBorrowFormNormalizedData): Objective[] {
  return formValues.deposits
    .filter((deposit) => deposit.value.gt(0))
    .map((deposit): Objective => {
      return {
        type: 'deposit',
        token: deposit.token,
        value: deposit.value,
      }
    })
}

function createBorrowObjectives(formValues: EasyBorrowFormNormalizedData): Objective[] {
  return formValues.borrows
    .filter((borrow) => borrow.value.gt(0))
    .map((borrow): Objective => {
      return {
        type: 'borrow',
        token: borrow.token,
        value: borrow.value,
      }
    })
}
